module.exports = __webpack_public_path__ + "img/LV3.6b9d505c.webp";